import { render, staticRenderFns } from "./TransferDueForm.vue?vue&type=template&id=149ee48b"
import script from "./TransferDueForm.vue?vue&type=script&lang=js"
export * from "./TransferDueForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports